<footer class="awisa-footer">
  <div class="container">
    <div class="row">
      <div *ngIf="isAwisa()" class="col-md-12 clear-padding-right">
        <div [innerHTML]="html"></div>
      </div>
    </div>
  </div>
</footer>
